import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "c0862cd0-dff0-4265-8068-9548aed19dec",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    shuffle: true,
    type: "number",
    prefixText: "The <b>SWR</b> is",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 2,
};
